import {
	IListAttrs,
	IListColumnConfig,
	IListOperations,
	toImmutableMap,
} from '@datachain/ui-sdk/common';
import { immerable, produce } from 'immer';
import { Map } from 'immutable';

import { SimulationColumnsItemEntity } from './simulation-columns-item.entity';

type ISimulationColumnsListEntity = IListAttrs<SimulationColumnsItemEntity>;

const entityDefaults: ISimulationColumnsListEntity = {
	elements: Map(),
	availableColumns: Map(),
};

export class SimulationColumnsListEntity
	implements
		ISimulationColumnsListEntity,
		IListOperations<SimulationColumnsListEntity, SimulationColumnsItemEntity>
{
	private [immerable] = true;
	public elements = entityDefaults.elements;
	public availableColumns = entityDefaults.availableColumns;

	public static build(
		availableCols: Array<IListColumnConfig<SimulationColumnsItemEntity>>
	): SimulationColumnsListEntity {
		const inst = new SimulationColumnsListEntity();
		inst.availableColumns = toImmutableMap(availableCols, 'field');
		return inst;
	}

	private constructor() {}

	public getAvailableColumns(): Map<
		string,
		IListColumnConfig<SimulationColumnsItemEntity>
	> {
		return this.availableColumns;
	}

	public getElements(): Map<string, SimulationColumnsItemEntity> {
		return this.elements;
	}

	public setElements(
		elems: Map<string, SimulationColumnsItemEntity>
	): SimulationColumnsListEntity {
		return produce(this, (draft: SimulationColumnsListEntity) => {
			draft.elements = elems;
		});
	}
}
